import APopover from 'views/pages/manage/common/a-popover';
import React, { useMemo, useState } from 'react';
import { generateProgressSteps } from 'modules/studentView/constant';
import TransferTimeline from 'modules/studentView/progressTimeLine';
import InfoIconSolid from "assets/img/svg/svgComponents/InfoIconSolid";
import { getProgressStepList } from '../../approvalConfig/utils';


const ViewExtensionTrackerTimeline = ({ text, row, resubmitHandler,fetchTrackerTimeLine,color }) => {

    const [steps, setSteps] = useState([]);
    console.log(text, 'text')

    const getTrackerTimeLine = async (referenceNumber) => {
        const res = await fetchTrackerTimeLine(referenceNumber)
        const logs = (res?.depositSlipDetailsAuditDTOList || []).map(item => ({
            ...item,
            title: item?.action,
        }));
        const formatedsteps = generateProgressSteps(getProgressStepList(res?.approverCount,resubmitHandler), logs);
        setSteps(formatedsteps);
    }

    return <APopover
        buttonComponent={(onClick, styles) => (
            <span
                onClick={(e) => {
                    onClick(e);
                    getTrackerTimeLine(row?.referenceNumber)
                }}
                style={{ cursor: "pointer" }}
            >
                <span className='ml-2'><InfoIconSolid color={color} /></span>
            </span>
        )}
        menuComponent={(closeForm) => (
            <TransferTimeline
                steps={steps}
                heading='Approval status'
                marginLeft='0px'
                marginBottom='0px'
                closeForm={closeForm}
            />
        )}
        // transformOriginVertical="bottom"
        // transformOriginHorizontal="right"
    />
}

export default ViewExtensionTrackerTimeline;